import React, { useState, useEffect } from 'react';

const getInitials = (value) => {
  if (!value) return 'A';
  return value?.split(' ')?.map((n) => n?.[0])?.join('')?.toUpperCase()?.slice(0, 2);
};

const ProfileSection = ({ profile, onSave, saving }) => {
  const [fullName, setFullName] = useState(profile?.fullName || '');

  useEffect(() => {
    setFullName(profile?.fullName || '');
  }, [profile?.fullName]);

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSave({ fullName });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <h2 className="text-lg font-semibold text-foreground mb-1">Profile Information</h2>
      <p className="text-sm text-muted-foreground mb-6">Update your name and view your account details</p>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="flex items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-primary/10 text-primary flex items-center justify-center text-xl font-semibold flex-shrink-0">
            {getInitials(fullName || profile?.email)}
          </div>
          <div>
            <p className="text-sm font-medium text-foreground">{profile?.email || '—'}</p>
            <p className="text-xs text-muted-foreground mt-0.5">Administrator</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Full Name</label>
            <input
              type="text"
              value={fullName}
              onChange={(e) => setFullName(e?.target?.value)}
              placeholder="Your name"
              className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-background text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-2">Email</label>
            <input
              type="email"
              value={profile?.email || ''}
              disabled
              className="w-full px-3 py-2 text-sm border border-border rounded-lg bg-muted text-muted-foreground cursor-not-allowed"
            />
            <p className="text-xs text-muted-foreground mt-1">Email is tied to your login and can't be changed here.</p>
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={saving}
            className="flex items-center gap-2 px-5 py-2.5 bg-primary text-primary-foreground rounded-xl text-sm font-medium hover:bg-primary/90 transition-colors disabled:opacity-50"
          >
            {saving && <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />}
            Save Changes
          </button>
        </div>
      </form>
    </div>
  );
};

export default ProfileSection;
